import { LayoutConfig } from '@spartacus/storefront';

import { UseCasePageLayout as SlbUseCasePageTemplate } from './slb-use-cases-page/layout';
import { Marketing3PageLayout as SlbMarketingPage3Template } from './slb-marketing3-page/layout';
import { WorkflowPageLayout as SlbWorkflowPageTemplate, WorkflowDetailsPageTemplate } from './slb-workflow-page/layout';
import { DomainPageLayout as SlbDomainPageTemplate } from './slb-domain-page/layout';
import { HomeFeaturePageLayout, HomePageLayout as MarketingHomePageTemplate } from './slb-home-page/layout';
import { VideoLibraryPageTemplate as SlbLandingPage2Template } from './slb-video-library-page/layout';
import { VideoPageTemplate as SlbPlayVideoPageTemplate } from './slb-video-page/layout';
import { CloudSolutionsLayout as CloudSolutionsPDPPageTemplate } from './slb-cloud-solutions-pdp/layout';
import { CloudSolutionsPdpLayout as SubscriptionPDPPageTemplate } from './slb-cloud-solutions-pdp/layout';
import { Landing2PageTemplate as LandingPage2Template } from './slb-landing2-page/layout';
import { SlbCartPageLayout as CartPageTemplate } from './slb-cart-page/layout'
import { SimulationLandingPageTemplate as SimulationLandingPageTemplate } from './slb-simulation-page/layout';
import { EdgeSolutionsLayout as ProductDetailsPageTemplate } from './slb-edge-solutions-pdp/layout';
import { StorageLandingPageTemplate as StorageLandingPageTemplate } from './slb-storage-page/layout';
import { SlbServicesPlpPageTemplate as ProductGridPageTemplate } from './slb-services-plp/layout';
import { SummaryLandingPageTemplate as SummaryLandingPageTemplate } from './slb-summary-page/layout';
import { ShippingAndBillingLandingPageTemplate as ShipmentLandingPageTemplate } from './slb-shipping-and-billing/layout';
import { PaymentLandingPageTemplate as PaymentLandingPageTemplate } from './slb-payment-page/layout';
import { ReviewOrderLandingPageTemplate as OrderReviewLandingPageTemplate } from './slb-review-order-page/layout';
import { OrderConfirmationLandingPageTemplate as OrderConfirmationLandingPageTemplate } from './slb-confirmation-page/layout';
import { SlbServicesPdpPageTemplate as ServiceProductDetailsPageTemplate } from './slb-services-pdp-page/layout';
import { SlbOceanPlpPageTemplate as OceanProductGridPageTemplate } from './slb-ocean-plp/layout';
import { SlbOceanPlpFeaturePageTemplate as PluginsAndExtensionsPageTemplate } from './slb-ocean-plp/layout';
import { SlbOceanPdpPageTemplate, SlbPluginAndExtensionsPDPPageTemplate } from './slb-ocean-pdp-page/layout';
import { ErrorPageLayout as ErrorPageTemplate } from './slb-error-page/layout';
import { LicenseHardwareLandingPageTemplate } from './slb-license-page/layout';
import { OrbitalLandingPageTemplate } from './slb-orbital-payment-page/layout';
import { OrderDetailsPageTemplate } from './slb-order-details-page/layout';
import { OrdersHistoryPageTemplate } from './slb-orders-history-page/layout';
import { OrderHistoryDetailsPageTemplate } from './slb-orders-history-details-page/layout';
import { OnlinePaymentHistoryPageTemplate } from './slb-online-payments/layout';
import { OnlinePaymentDetailsPageTemplate } from './slb-online-payments-details/layout';
import { OnlineNewPaymentPageTemplate } from './slb-new-payment-invoice-details/layout';
import { OnlinePaymentInformationPageTemplate } from './slb-new-payment/layout';
import { OnlinePaymentSummaryPageTemplate } from './slb-new-payment-summary/layout';
import { OnlinePaymentConfirmationPageTemplate } from './slb-new-payment-confirmation/layout';
import { MaintenanceRenewalPageTemplate } from './slb-maintenance-renewal-page/layout';
import { LandingPage4Template } from './slb-landing-page/layout';
import { LandingPage5Template } from './slb-landing-page/layout';
import { LandingPage6Template } from './slb-marketing/layout';
import { MyAccountPageTemplate } from './slb-user-preference/layout';
import { SubscriptionCategoryPageTemplate, SubscriptionPackagePDPPageTemplate } from './slb-subscriptions-pages/layout';
import { ApplicationDetailsPageTemplate } from './slb-application-page/layout';

export const slbLayoutSlots: LayoutConfig['layoutSlots'] = {
  SlbUseCasePageTemplate,
  SlbMarketingPage3Template,
  SlbWorkflowPageTemplate,
  SlbDomainPageTemplate,
  MarketingHomePageTemplate,
  SlbLandingPage2Template,
  SlbPlayVideoPageTemplate,
  LandingPage2Template,
  SubscriptionCategoryPageTemplate,
  CartPageTemplate,
  CloudSolutionsPDPPageTemplate,
  SubscriptionPDPPageTemplate,
  SimulationLandingPageTemplate,
  ProductDetailsPageTemplate,
  StorageLandingPageTemplate,
  ProductGridPageTemplate,
  SummaryLandingPageTemplate,
  ShipmentLandingPageTemplate,
  PaymentLandingPageTemplate,
  OrderReviewLandingPageTemplate,
  CategoryPageTemplate: ProductGridPageTemplate,
  SearchResultsGridPageTemplate: ProductGridPageTemplate,
  SearchOceanResultsGridPageTemplate: OceanProductGridPageTemplate,
  OceanProductGridPageTemplate,
  PluginsAndExtensionsPageTemplate,
  OceanCategoryPageTemplate: OceanProductGridPageTemplate,
  OrderConfirmationLandingPageTemplate,
  ServiceProductDetailsPageTemplate,
  OceanProductDetailsPageTemplate: SlbOceanPdpPageTemplate,
  PluginsAndExtensionsProductDetailsPageTemplate: SlbPluginAndExtensionsPDPPageTemplate,
  ErrorPageTemplate,
  LandingOceanPage2Template: OceanProductGridPageTemplate,
  LicenseHardwareLandingPageTemplate,
  OrbitalLandingPageTemplate,
  OrderDetailsPageTemplate,
  NotFoundPageTemplate: ErrorPageTemplate,
  OrdersHistoryPageTemplate,
  OrderHistoryDetailsPageTemplate,
  OnlinePaymentHistoryPageTemplate,
  OnlinePaymentDetailsPageTemplate,
  OnlineNewPaymentPageTemplate,
  OnlinePaymentInformationPageTemplate,
  OnlinePaymentSummaryPageTemplate,
  OnlinePaymentConfirmationPageTemplate,
  MaintenanceRenewalPageTemplate,
  LandingPage4Template,
  LandingPage5Template,
  LandingPage6Template,
  MyAccountPageTemplate,
  WorkflowDetailsPageTemplate,
  SubscriptionPackagePDPPageTemplate,
  MktHomePageTemplate: HomeFeaturePageLayout,
  ApplicationDetailsPageTemplate
}
